import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AuraLayout,
  Layout,
  PageTitle,
  CashSpecialIcon,
} from 'lola-framework-ui-test';
import { FlowHeroMark } from '../components/FlowHeroMark';
import { ScrollFadeIndicator } from '../components/ScrollFadeIndicator';

import { useStore } from '../store/globalState';
import { amountFormatter } from '../utils';
import {
  CASH_DEPOSIT_AMOUNT,
  CASH_DEPOSIT_CURRENCY,
} from '../gallery/cashDepositMock';

/**
 * Gallery-safe cash-deposit verification screen.
 *
 * Mirrors SendingMoneyPage layout: spinner + title + amount while the
 * deposit is being verified.
 */
export const PaymentVerificationPage = memo(() => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const colorConfig = theme.whiteView;
  const { dropzoneColors, bodyCopy, backgroundIcon } = colorConfig;

  return (
    <AuraLayout colorConfig={colorConfig} className="flow-landing-page">
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark
            showSpinner
            dropzoneColors={dropzoneColors}
            backgroundIcon={backgroundIcon}
          >
            <CashSpecialIcon size={60} colors={dropzoneColors} />
          </FlowHeroMark>
          <section className="landing-container">
            <PageTitle
              highlight={t('cashDeposit.verifying')}
              highlightColor={bodyCopy}
              secudnary={`$${amountFormatter(CASH_DEPOSIT_AMOUNT)} ${CASH_DEPOSIT_CURRENCY}`}
              secudnaryColor={bodyCopy}
            />
          </section>
        </section>
      </Layout.Content>
    </AuraLayout>
  );
});
